<div class="ModuleList">
  <div class="ModuleList_Container">
    <div class="snapshot-area">
      <!-- <div class="Data_Explorer_txt" (click)="showSnapshotDropdown()" id="snapshot-text">SNAPSHOT</div> -->
      <div class="Data_Explorer_txt" id="snapshot-text">{{ headerTitle }}</div>
      <!-- <div class="header_border"></div>
      <div class="SnapshotListArea" *ngIf="showSnapshotDropdownVal" id="snapshot-dropdown">
        <div class="diamond"></div>
        <div class="snapshotDropdown" *ngFor="let snap of snapshotListData[0].UniqueSnapshots != undefined ? snapshotListData[0].UniqueSnapshots : snapshotListData[0].UniqueStudies">
          <div class="snapshotDropdown_Container" (click)="navigateSnapshot(snap)">
            <div class="snapshotDropdown_Container_Name" [class.selected_Text]="snap === selected_Snap">{{ snap }}</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <!-- (click)="navigateToModule(module.name)" -->
